import getRole from "../auth/getRole";
import { Roles, permissionNames } from "../consts/constants";
import navigations from "./routeNames";

const checkAuthorisation = ({ permissions, requestedRoute }) => {
  const doesContainRoute = (route) => {
    return requestedRoute?.toLowerCase().includes(route?.toLowerCase());
  };
  const role = getRole();
  const isDentistRoute = /^\/dentist(?:\/|$)/i.test(requestedRoute);

  if (
    (isDentistRoute || doesContainRoute(navigations.HOME)) &&
    role !== Roles.dentist
  ) {
    return false;
  }
  if (
    role !== Roles.admin &&
    (doesContainRoute(navigations.PURCHASE_ONLINE_PROGRAMS) ||
      doesContainRoute(navigations.SUBSCRIPTIONS))
  ) {
    return false;
  }
  if (
    role === Roles.admin &&
    doesContainRoute(navigations.ONLINE_PROGRAM_REQUEST)
  ) {
    return true;
  }
  if (
    role === Roles.admin &&
    doesContainRoute(navigations.CADAVER_PROGRAM) &&
    !permissions.includes(permissionNames.cadaverProgram)
  ) {
    return false;
  }
  if (
    role === Roles.admin &&
    doesContainRoute(navigations.LIVE_EXTERNSHIP_DENTAL_ASSISTANT) &&
    !permissions.includes(permissionNames.dentalAssistantObservationTrack)
  ) {
    return false;
  }
  if (
    role === Roles.admin &&
    doesContainRoute(navigations.MASTER_OF_ORAL_IMPLANTOLOGY) &&
    !permissions.includes(permissionNames.masterOfOralImplantologyProgram)
  ) {
    return false;
  }
  if (
    role === Roles.admin &&
    doesContainRoute(navigations.LIVE_EXTERNSHIP_OBSERVATION) &&
    !permissions.includes(permissionNames.observationTrack)
  ) {
    return false;
  }
  if (
    role === Roles.admin &&
    doesContainRoute(navigations.LIVE_EXTERNSHIP) &&
    !permissions.includes(permissionNames.externship)
  ) {
    return false;
  }
  if (
    role === Roles.admin &&
    doesContainRoute(navigations.ONLINE_PROGRAM) &&
    !permissions.includes(permissionNames.onlineProgram)
  ) {
    return false;
  }

  if (permissions) {
    if (doesContainRoute(navigations.SAAS)) {
      return permissions?.includes(permissionNames.saasAdmin);
    }
    if (doesContainRoute(navigations.ACCOUNTS)) {
      return permissions?.includes(permissionNames.account);
    }
    if (doesContainRoute(navigations.USERS)) {
      return permissions?.includes(permissionNames.user);
    }
    if (doesContainRoute(navigations.SPEAKERS)) {
      return permissions?.includes(permissionNames.speakers);
    }
    if (doesContainRoute(navigations.SUBSCRIPTIONS)) {
      return permissions?.includes(permissionNames.subscriptions);
    }
    if (doesContainRoute(navigations.PURCHASE_ONLINE_PROGRAMS)) {
      return permissions?.includes(permissionNames.purchaseOnlinePrograms);
    }
    if (doesContainRoute(navigations.USERS_TEST_ATTEMPTS)) {
      return permissions?.includes(permissionNames.onlineProgramTestAttempts);
    }
    if (doesContainRoute(navigations.ONLINE_PROGRAM)) {
      return permissions?.includes(permissionNames.onlineProgram);
    }
    if (doesContainRoute(navigations.MASTER_OF_ORAL_IMPLANTOLOGY)) {
      return permissions?.includes(
        permissionNames.masterOfOralImplantologyProgram,
      );
    }
    if (doesContainRoute(navigations.LIVE_EXTERNSHIP)) {
      return permissions?.includes(permissionNames.externship);
    }
    if (doesContainRoute(navigations.LIVE_EXTERNSHIP_OBSERVATION)) {
      return permissions?.includes(permissionNames.observationTrack);
    }
    if (doesContainRoute(navigations.LIVE_EXTERNSHIP_DENTAL_ASSISTANT)) {
      return permissions?.includes(
        permissionNames.dentalAssistantObservationTrack,
      );
    }
    if (doesContainRoute(navigations.CADAVER_PROGRAM)) {
      return permissions?.includes(permissionNames.cadaverProgram);
    }

    return true;
  }
  if (doesContainRoute(navigations.SUBCAT) && role === Roles.dentist) {
    return true;
  }
  if (doesContainRoute(navigations.GROUPS) && role === Roles.dentist) {
    return true;
  }
  if (doesContainRoute(navigations.HOME) && role === Roles.dentist) {
    return true;
  }
  if (doesContainRoute(navigations.DENTIST_SETTING) && role === Roles.dentist) {
    return true;
  }

  return false;
};

export default checkAuthorisation;
